<template>
  <ApartmentSearchFormMinimal
    @submit-all-types-minimal="onSubmit"
    :size="size"
    :preset="preset"
    :show_campaign="show_campaign"
  />
</template>

<script>
  import globals from '../lib/globals';
  import ApartmentSearchFormMinimal from './components/ApartmentSearchFormMinimal';
  //import HiddenFormFields from './components/HiddenFormFields';

  export default {
    components: {
      //HiddenFormFields,
      ApartmentSearchFormMinimal,
    },
    props: {
      size: {
        type: String,
        default: 'full',
      },
      preset: {
        type: Object,
        default: null,
      },
      show_campaign: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      onSubmit(form, stateString) {
        window.location.href = `${globals.urlApartmentSearch}?q=${stateString}`;
      },
    },
  }
</script>
